<template>
	<iframe
		ref="composer"
		class="composer embed"
		id="vendasta-composer"
		data-test="composer"
		v-bind:src="composerUrl"
		title="Composer"
		@load="handleVendastaLoaded"
	></iframe>
</template>

<script>
import socialMarketingService from '@/services/toolbox/social-marketing-service';

export default {
	name: 'Composer',
	props: {
		scheduleDate: {
			type: Date,
			default: new Date(),
		},
		mediaData: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			composerDomain: 'https://united-shore-financial-services-llc.socialsmbs.com',
			composerUrl: '',
		};
	},
	methods: {
		async startComposer() {
			try {
				const response = await socialMarketingService.getComposerUrl();
				this.composerUrl = response.data;
			} catch (error) {
				console.error('Error fetching composer URL:', error);
			}
		},
		handleVendastaLoaded() {
			this.displayComposer();
			if (this.scheduleDate > new Date()) {
				this.setScheduledDate([this.scheduleDate]);
			}
		},
		sendMessage(message, args = []) {
			if (this.$refs.composer && this.$refs.composer.contentWindow) {
				this.$refs.composer.contentWindow.postMessage(
					{
						class: 'ComposerComponent',
						function: message,
						args,
					},
					this.composerDomain,
				);
			}
		},
		displayComposer() {
			this.sendMessage('displayComposerOnly');
		},
		displayPreview() {
			this.sendMessage('displayPreviewOnly');
		},
		removeComposerToolbar() {
			this.sendMessage('removeToolbar');
		},
		removePostButton() {
			this.sendMessage('hidePostButton');
		},
		addMedia(mediaArray) {
			this.sendMessage('addMedia', mediaArray);
		},
		removeMedia() {
			this.sendMessage('clearMedia');
		},
		setScheduledDate(dateArray) {
			this.sendMessage('setScheduledDate', dateArray);
		},
		setServices(servicesArray) {
			this.sendMessage('selectServices', servicesArray);
		},
		submitPost() {
			this.sendMessage('submitPost');
		},
	},
	watch: {
		scheduleDate() {
			let currentDate = new Date();

			if (this.scheduleDate > currentDate) {
				this.setScheduledDate([this.scheduleDate]);
			} else {
				currentDate.setHours(currentDate.getHours() + 1);
				this.setScheduledDate([currentDate]);
			}
		},
	},
	mounted() {
		this.startComposer();
	},
};
</script>

<style lang="scss" scoped>
#vendasta-composer {
	position: absolute;
	top: 40px; /* this accounts for the Compose Nav menu height tablet and above resolutions */
	height: calc(100vh - 240px);
	@include rem(min-height, 640px);
	left: 0;
	width: 100%;
	border: 0;
	min-height: 100%;
}

.suggested-post-modal {
	#vendasta-composer {
		position: absolute;
		height: calc(100vh - 240px);
		@include mobile {
			height: calc(100vh - 309px);
		}
		@media only screen and (max-width: 620px) {
			top: 59px;
		}
		@media only screen and (max-width: 375px) {
			top: 78px;
			height: calc(100vh - 328px);
		}
		left: 0;
		width: 100%;
		border: 0;
		min-height: 100%;
	}
}

.social-share-modal {
	#vendasta-composer {
		height: calc(100vh - 300px);
		@include mobile {
			height: calc(100vh - 360px);
		}
	}
}
</style>
